module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inputrow",
    attrs: {
      "width": "100"
    }
  }, [_c('div', {
    staticClass: "fleft"
  }, [_c('span', {
    staticClass: "smart",
    on: {
      "click": function($event) {
        return _vm.useSmart(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.smart))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.garment_left),
      expression: "garment_left"
    }],
    staticClass: "garment",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.garment_left)
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.garment_left = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fright"
  }, [_c('span', {
    staticClass: "smart",
    on: {
      "click": function($event) {
        return _vm.useSmart(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.smart))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.garment_right),
      expression: "garment_right"
    }],
    staticClass: "garment",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.garment_right)
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.garment_right = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "smart-measurements"
  }, [_vm._v("S: " + _vm._s(_vm.smartMeasurements))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "label fleft"
  }, [_vm._v("GAUCHE")]), _vm._v(" "), _c('div', {
    staticClass: "label fright"
  }, [_vm._v("DROITE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf8abdc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GarmentConfig2.vue
// module id = 480
// module chunks = 1